import { NameIdOption } from "../../common/types/commonTypes";

export const formatCitiesToNameIdOptions = (cities: string[]): NameIdOption[] =>
  [...new Set(cities)].map((city) => ({
    id: city,
    name: city,
  }));
